/*
 * Cart page size chart modal.
 *
 * Buttons are rendered by snippets/cart-size-chart.liquid. The listener is delegated on the document because the
 * cart section replaces its markup after every quantity change. The dialog is created on first use and the chart
 * image is only requested when a customer opens it.
 */
(function () {
  if (window.cartSizeChartReady) return;
  window.cartSizeChartReady = true;

  var OPEN_CLASS = 'cart-size-chart-open';
  var CLOSE_ICON =
    '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"></path>' +
    '</svg>';

  var dialog = null;
  var image = null;
  var titleEl = null;
  var closeButton = null;
  var activeTrigger = null;
  var pressTarget = null;

  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'cart-size-chart-modal';
    dialog.setAttribute('aria-labelledby', 'cart-size-chart-title');
    dialog.innerHTML =
      '<div class="cart-size-chart-modal__content">' +
      '<div class="cart-size-chart-modal__header">' +
      '<h2 class="cart-size-chart-modal__title heading-font" id="cart-size-chart-title"></h2>' +
      '<button type="button" class="cart-size-chart-modal__close">' +
      CLOSE_ICON +
      '</button>' +
      '</div>' +
      '<div class="cart-size-chart-modal__body">' +
      '<img class="cart-size-chart-modal__image" alt="" decoding="async">' +
      '</div>' +
      '</div>';
    document.body.appendChild(dialog);

    image = dialog.querySelector('.cart-size-chart-modal__image');
    titleEl = dialog.querySelector('.cart-size-chart-modal__title');
    closeButton = dialog.querySelector('.cart-size-chart-modal__close');

    closeButton.addEventListener('click', function () {
      dialog.close();
    });

    // Close on backdrop click only when the press and the release both happened on the backdrop, so dragging
    // a selection out of the modal does not dismiss it.
    dialog.addEventListener('mousedown', function (event) {
      pressTarget = event.target;
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog && pressTarget === dialog) dialog.close();
      pressTarget = null;
    });

    // Fires for the close button, backdrop click and the Escape key. The event is dispatched asynchronously, so
    // ignore it if the dialog has already been reopened; otherwise it would clear the new session's state.
    dialog.addEventListener('close', function () {
      if (dialog.open) return;
      document.documentElement.classList.remove(OPEN_CLASS);
      if (activeTrigger && document.contains(activeTrigger)) activeTrigger.focus();
      activeTrigger = null;
    });

    // Never leave a broken image on screen: close the modal and hide every button that points at the failed file.
    image.addEventListener('error', function () {
      var failedSrc = image.getAttribute('src');
      if (!failedSrc) return;
      image.removeAttribute('src');
      if (dialog.open) dialog.close();
      document.querySelectorAll('[data-cart-size-chart-open]').forEach(function (button) {
        if (button.getAttribute('data-size-chart-src') === failedSrc && button.parentNode) {
          button.parentNode.hidden = true;
        }
      });
    });
  }

  function openChart(trigger) {
    var src = trigger.getAttribute('data-size-chart-src');
    if (!src) return;

    // Very old browsers without <dialog>: fall back to the image itself in a new tab.
    if (typeof HTMLDialogElement !== 'function') {
      window.open(src, '_blank', 'noopener');
      return;
    }

    if (!dialog) buildDialog();

    var product = trigger.getAttribute('data-size-chart-product') || '';
    var heading = trigger.getAttribute('data-size-chart-heading') || 'Size chart';
    var scheme = trigger.getAttribute('data-size-chart-scheme');

    activeTrigger = trigger;
    dialog.className = 'cart-size-chart-modal' + (scheme ? ' scheme-' + scheme : '');
    titleEl.textContent = product ? heading + ' – ' + product : heading;
    closeButton.setAttribute('aria-label', trigger.getAttribute('data-size-chart-close') || 'Close');
    image.alt = product ? product + ' – ' + heading : heading;
    if (image.getAttribute('src') !== src) image.setAttribute('src', src);

    document.documentElement.classList.add(OPEN_CLASS);
    dialog.showModal();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-cart-size-chart-open]') : null;
    if (!trigger) return;
    event.preventDefault();
    openChart(trigger);
  });
})();
